import { useQuery } from "@tanstack/react-query";
import { graphierQLNextClient } from "utils";
import {
	SpatialQueryPropertiesQuery,
	SpatialQueryPropertiesQueryVariables,
} from "~map-view/types/__generated/gql/graphql";

const query = /* GraphQL */ `
	query SpatialQueryProperties(
		$input: SpatialQueryInput!
		$limit: Int!
		$offset: Int!
	) {
		spatialQueryProperties(input: $input, limit: $limit, offset: $offset) {
			total
			items {
				gid
				properties
				bbox
				point
			}
			processTime
		}
	}
`;

export const useSpatialQueryProperties = (
	variables: SpatialQueryPropertiesQueryVariables,
) => {
	return useQuery({
		enabled: false,
		queryKey: ["spatialQueryProperties", variables],
		queryFn: () =>
			graphierQLNextClient<
				SpatialQueryPropertiesQuery,
				SpatialQueryPropertiesQueryVariables
			>({
				query,
				variables,
				useKey: true,
			}).then((res) => res.spatialQueryProperties),
	});
};
